import * as React from 'react';

import { ThemeProvider, useTheme } from '../../../../../../theme';
import { Animal as AnimalRoot } from '../../../../../../CheckoutAdditionalService/components';

interface Props {
	segmentId?: string;
}

const Animal: React.FC<Props> = ({ segmentId }) => {
	const { ServicesAggregationPage: theme } = useTheme('Checkout');

	return (
		<ThemeProvider value={{ CheckoutAdditionalService: { Animal: { container: theme.animal } } }}>
			<AnimalRoot segmentId={segmentId} aggregationIcons={['Baggage/Pet in cabin']} aggregationMode />
		</ThemeProvider>
	);
};

export default Animal;
